// src/utils/demoIdentity.js
//
// Demo-only display identity. Hard-coded greeting name so the header
// bar's "Welcome, {name}" text has something to render before SSO is
// wired.
//
// TODO (Okta cutover): replace with the JWT `given_name` claim from
// the authenticated session. See docs/DEMO_ONLY_INVENTORY.md item 2.

export const DEMO_USER_NAME = "Corey";
